import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd9ee742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "fullscreen-modal__top-title" }
const _hoisted_5 = { class: "fullscreen-modal__title mb-3 mb-md-48" }
const _hoisted_6 = { class: "col-12 my-3" }
const _hoisted_7 = { class: "d-md-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "d-md-flex align-items-center" }
const _hoisted_9 = { class: "ticket-configuration__small-title mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-light-grey d-md-block d-none mx-2" }, "|", -1))
const _hoisted_11 = { class: "ticket-configuration__date my-2 my-md-0" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "ticket-configuration__status-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_TimeListConfigurations = _resolveComponent("TimeListConfigurations")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate('shop.configuration.choose-rides')), 1),
        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_Breadcrumb, {
          step: _ctx.step,
          onChangeStep: _ctx.onChangeStep,
          stepViews: _ctx.stepViews,
          type: "activity"
        }, null, 8, ["step", "onChangeStep", "stepViews"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.title), 1),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getLocaleDayOfMonthOfISO(_ctx.selectedDateEnd)) + ". " + _toDisplayString(_ctx.getLocaleMonthNameOfISO(_ctx.selectedDateEnd)) + " " + _toDisplayString(_ctx.getLocaleYearOfISO(_ctx.selectedDateEnd)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass('ticket-configuration__status is-'+ _ctx.availability.status )
              }, null, 2),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.availability.total) + " " + _toDisplayString(_ctx.translate('shop.configuration.ticket.available spaces')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_Transition, {
        name: "login-fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TimeListConfigurations, {
            title: _ctx.translate('shop.configuration.add-persons-from-age-groups'),
            allPriceGroups: _ctx.allPriceGroups,
            "ticket-configuration": _ctx.ticketConfigurations,
            selectedCurrency: _ctx.selectedCurrency,
            timeList: _ctx.timeList,
            onChangePriceGroupCounter: _ctx.onChangePriceGroupCounter
          }, null, 8, ["title", "allPriceGroups", "ticket-configuration", "selectedCurrency", "timeList", "onChangePriceGroupCounter"])
        ]),
        _: 1
      })
    ])
  ]))
}